<template>
  <div>
    <!-- <BasicTable ref="table" :get-data="getData" :fields="fields">
      <template #head(createdOn)="data">
        <div style="width: 180px">{{ data.label.toUpperCase() }}</div>
      </template>
      <template #head(lastModifiedOn)="data">
        <div style="width: 180px">{{ data.label.toUpperCase() }}</div>
      </template>
      <template #head(lastModifiedByUser)="data">
        <div style="width: 180px">{{ data.label.toUpperCase() }}</div>
      </template>
      <template #head(parentName)="data">
        <div style="width: 100px">{{ data.label.toUpperCase() }}</div>
      </template>
      <template #head(vaultName)="data">
        <div style="width: 100px">{{ data.label.toUpperCase() }}</div>
      </template>
    </BasicTable> -->
    <BasicScrollTable ref="table" :data="tableData" :table-loading="table_loading" @loadScroll="loadMore">
      <el-table-column show-overflow-tooltip label="Name" prop="name" />
      <el-table-column show-overflow-tooltip label="Parent Name" prop="parentName" />
      <el-table-column show-overflow-tooltip label="Vault Name" prop="vaultName" />
      <el-table-column show-overflow-tooltip label="Path Name" prop="pathName" />
      <el-table-column show-overflow-tooltip label="Created On" prop="createdOn">
        <template v-slot="{ row }">
          <div style="width: 180px">{{ row.createdOn | renderTime }}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="Last Modified On" prop="lastModifiedOn">
        <template v-slot="{ row }">
          <div style="width: 180px">{{ row.lastModifiedOn | renderTime }}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="Created By User" prop="createdByUser" />
      <el-table-column show-overflow-tooltip label="Last Modified By User" prop="lastModifiedByUser" />
    </BasicScrollTable>
  </div>
</template>

<script>
import BasicScrollTable from '@core/components/common/BasicScrollTable'
import { TabIndex } from '@core/utils/common'
import tableScroll from '@core/mixins/tableScroll'

export default {
  components: { BasicScrollTable },
  mixins: [tableScroll],
  data() {
    return {
      fields: ['_id', 'name', 'parentName', 'vaultName', 'pathName', 'createdOn', 'lastModifiedOn', 'createdByUser', 'lastModifiedByUser'],
      type2: 'folder',
      eventName: `${TabIndex.folder}:${this.type}`
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped></style>
